import { useState } from "react";
import { useHistory } from "react-router-dom";

import { useAuthenticationManager } from "scenes/Authentication/hooks/useAuthenticationManager";

export function useSignUpForm() {
  const { signUp, isProcessing } = useAuthenticationManager();
  const [error, setError] = useState();
  const history = useHistory();

  return {
    loading: isProcessing,
    error: error,
    signUp: async ({ email: e, password: p }) => {
      setError("");
      try {
        await signUp(e, p);
        history.push(`/v2/confirm/${e}${history.location.search}`);
      } catch (err) {
        setError(err?.message || "Failed to sign up");
      }
    },
  };
}

export default useSignUpForm;
